import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, getCurrentInstance } from "vue";

const __default__ = {
  name: "GlobalLoginDialog",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  showLogin: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:showLogin"],
  setup(__props, { emit: emits }) {

const props = __props

const { proxy } = getCurrentInstance() as any;


let _showLogin = ref<boolean>(props.showLogin);

const loginFn = (): void => {
  _showLogin.value = false;
  proxy.$Message({
    type: "success",
    message: "登录成功",
  });
  // 登录成功后刷新页面，避免原来页面的请求由于没有权限请求不到数据
  window.location.reload();
};

watch(
  () => props.showLogin,
  (newVal) => {
    _showLogin.value = newVal;
  }
);

watch(
  () => _showLogin.value,
  (newVal) => {
    emits("update:showLogin", newVal);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_login_view = _resolveComponent("login-view")!
  const _component_mas_modal = _resolveComponent("mas-modal")!

  return (_openBlock(), _createBlock(_component_mas_modal, {
    visible: _unref(_showLogin),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(_showLogin) ? (_showLogin).value = $event : _showLogin = $event)),
    width: "550px",
    title: "登录过期或者已经在其他地方登录，请重新登录",
    customFooterBtns: "",
    customClass: "hbb-dialog-modal",
    closeOnClickModal: false
  }, {
    content: _withCtx(() => [
      _createVNode(_component_login_view, { onLoginEvent: loginFn })
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})